function isWindow(obj) {
    return obj != null && obj == obj.window
}

isObject = function(obj) {
    return typeof obj == 'object'
}
isPlainObject = function(obj) {
    return isObject(obj) && !isWindow(obj) && Object.getPrototypeOf(obj) == Object.prototype
}

isArray =
    Array.isArray ||
    function(object) {
        return object instanceof Array
    }

function _extend(target, source, deep) {
    for (let key in source) {
        if (deep) {
            if (isPlainObject(source[key]) && isPlainObject(target[key])) {
                target[key] = {}
                _extend(target[key], source[key], deep)
            } else if (isArray(source[key]) && !isArray(target[key])) {
                target[key] = []
                _extend(target[key], source[key], deep)
            } else if (source[key] !== undefined) {
                target[key] = source[key]
            }
        } else if (source[key] !== undefined) {
            target[key] = source[key]
        }
    }
}

// Copy all but undefined properties from one or more
// objects to the `target` object.
extend = function(target) {
    var deep,
        args = Array.prototype.slice.call(arguments, 1)
    if (typeof target == 'boolean') {
        deep = target
        target = args.shift()
    }
    args.forEach(function(arg) {
        _extend(target, arg, deep)
    })
    return target
}

function setTable(correctKey = true, t, key, value) {
    if (arguments.length === 3) {
        table.insert(t, key)
    } else {
        if (correctKey) {
            let numberKey = parseInt(key, 10)
            let realKey = numberKey.toString() === key ? numberKey + 1 : key
            t[realKey] = value
        } else {
            t[key] = value
        }
    }
}

function getTableOrObject(source, isStrict) {
    // plain object
    if (!isStrict && Object.getPrototypeOf(source) === Object.prototype) {
        return {}
    } else {
        return table()
    }
}

function _$table(target, source, isStrict) {
    // 因为lua中table序数从1开始
    // 转换时，非LuaTable的数组，序数需要+1
    let correctKey = !source.__isLuaTable && isArray(source)
    for (let key in source) {
        let value = source[key]
        if (value && isObject(value)) {
            let t = getTableOrObject(value, isStrict)
            setTable(correctKey, target, key, t)
            _$table(t, value, isStrict)
        } else {
            setTable(correctKey, target, key, value)
        }
    }
}

// isStrict 非严格模式下 Object 不会转成 table，可以显著提高性能
// 但是在某些非标准的情况（将array当做object使用）下会有问题
$table = function(source, isStrict = true) {
    let result = getTableOrObject(source, isStrict)
    _$table(result, source, isStrict)
    return result
}

$tableToObj = function(t) {
    let target = {}
    if (!t) {
        return target
    }
    for (var key in t) {
        var element = t[key]
        if (element === undefined || element === null) {
            continue
        }
        // if (element.__isLuaTable || isArray(element)) {
        if (element.__isLuaTable) {
            target[key] = $tableToObj(element)
        } else {
            target[key] = element
        }
    }
    return target
}

$tableToArray = function(t) {
    t = t.__isLuaTable ? t.slice(1) : t
    delete t.__isLuaTable
    return t
}

$arrayToTable = function(t) {
    return t.__isLuaTable? t: table(t);
}

// noop function
$noop = function () {}

$next = function(t, index) {
    if (t == null)
        return null;

    let keys = Object.getOwnPropertyNames(t);
    /**
     * 这里改动 是因为table数组key如下 所以取值要从3开始目前用的少看起来没有问题
     * 0: "0"
        1: "length"
        2: "__isLuaTable"

     */
    
    let s = 3//
    let key = index == null? keys[s]: keys[index + s];
    return key == null? null: t[key];
} 

throttle = function(func, wait) {
    var ctx, args, rtn, timeoutID
    var last = 0

    return function throttled() {
        ctx = this
        // cc.log("throttled",ctx)
        args = arguments
        var delta = new Date() - last
        if (!timeoutID) {
            if (delta >= wait) {
                call()
            } else {
                timeoutID = setTimeout(call, wait - delta)
                // cc.log("throttledxxx", timeoutID)
            }
        }
        return rtn
    }

    function call() {
        last = +new Date()
        rtn = func.apply(ctx, args)
        // cc.log("throttled  clear")
        timeoutID = 0
        // 递归调用的时候如果在这里清除了 ctx 与 args 会导致 setTimeout的调用出错
        // ctx = null
        // args = null
    }
}

let _obj_ref = {}
let InstanceIdCount = 1
addToObjRef = function(obj) {
    let id = InstanceIdCount++
    obj.__hId = id
    _obj_ref[id] = obj
}

getObjRef = function(id) {
    return _obj_ref[id]
}

delObjRef = function(id) {
    return delete _obj_ref[id]
}

$bool = function(val) {
    if (val || val === '' || val === 0) {
        return true
    } else {
        return false
    }
}

$or = function(...args) {
    for (let i = 0; i < args.length; i++) {
        if ($bool(args[i]))
            return args[i];
    }
    return args[args.length - 1];
}

getParameterExtra = function() {
    var name = 'extra'
    var url = window.location.href
    name = name.replace(/[\[\]]/g, '\\$&')
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url)

    var value
    if (!results) {
        value = null
    } else if (!results[2]) {
        value = ''
    } else {
        value = b64Decode(results[2].replace(/\+/g, ' '))
    }
    return value
}

// getParentParameterByName = function (name) {
//     var url = parent.location.href;
//     name = name.replace(/[\[\]]/g, "\\$&");
//     var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
//         results = regex.exec(url);
//     if (!results) return null;
//     if (!results[2]) return '';
//     return decodeURIComponent(results[2].replace(/\+/g, " "));
// }

let oldMod = Math.mod
Math.mod = function(num1, num2) {
    if (oldMod) {
        return oldMod(num1, num2)
    } else {
        return num1 % num2
    }
}

// for unicode
b64Encode = function(str) {
    let btoa = btoa ? btoa : Base64.btoa
    return btoa(
        encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function(match, p1) {
            return String.fromCharCode('0x' + p1)
        })
    )
}

b64Decode = function(str) {
    let atob = atob ? atob : Base64.atob
    return he.HeDisplayUtil.urlDecode(
        Array.prototype.map
            .call(atob(str), function(c) {
                return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
            })
            .join('')
    )
}

isWX = function() {
    return META.user.app == 'wx'
}

isWxPlatform = function() {
    return META.platform.indexOf('wx_') == 0
}

gotoWxPlatformLogin = function() {
    return alert('TODO: goto wx platform login')
}

// alert = function (text) {
//     mqq.invoke("ui", "showDialog", {
//         text: text,
//         needOkBtn: true,
//         needCancelBtn: false,
//         okBtnText: "确定",
//     },function(data){
//     });
// }

// 启动获取前端配置请求的参数
getClientConfigParams = function(method){
    const RES_VERSION = getParameterByName('_resver')
    let mainVersion = RES_VERSION ? RES_VERSION : (META.getGameVersion() || "")
    let deviceInfo = getDeviceInfo()
    let device = "iOS"
    if (deviceInfo){
        device = deviceInfo.platform || "iOS"
    }
    _G.isOHOS = (device == "ohos")
    let pf = isWechatGameEnv()? mini.getPlatform(): META.platform;
    let param = [{},[{"method": method ,"ver": mainVersion, "device": device,"encyptKeyVersion": window.HTTP_SECRET_KEY_VERSION,pf: pf}]]

    return param
}

// isPreGet:默认空，只有微信因为获取code时长不稳定需要提前获取code
// forceNewCode:默认未空 现在只有恢复账号和上一次登录失败自动重试的时候使用，提前预获取的code可能已经被使用所以需要重新获取
getCurrentEvt = function(callback, isPreGet, forceNewCode) {
    if (isPreGet == null){
        isPreGet = false
    }
    let game_version = window.META.version
    if (getCurrentPlatform() == XcloverPlatform.huawei){ //huawei
        GameProxy.getInstance().getLoginInfo(function(data) {
            // if (oldOpenKey !== data.openkey) {
            //     DCAssist.userTrack("error", "openKeyNotMatck", { old: oldOpenKey, data: data.openkey })
            //     META.user.openkey = data.openkey
            // }
            // window.OPEN_DATA.openid = data.openid
            // window.OPEN_DATA.openkey = data.openkey
 

            let launchOptions = getLaunchOptions();
            let loginInfo = {}
            try {
                let avatarUrl = ""
                if (data && data.hiResImageUri){
                    avatarUrl = data.hiResImageUri.length > 0 ? data.hiResImageUri : data.imageUri
                }
                loginInfo = {
                    // openid: data.openid,
                    // openkey: data.openkey,
                    // serverid: window.OPEN_DATA.platform,
                    pf: window.META.user.platform,
                    op: 'login',
                    h5game_openid: data.playerId,
                    ts: data.ts,
                    player_level: data.playerLevel,
                    player_sign: data.gameAuthSign,
                    is_auth: data.isAuth,
                    nickName: data.displayName,
                    // avatarUrl: data.hiResImageUri.length > 0 ? data.hiResImageUri : data.imageUri,
                    avatarUrl: "",
                    src: launchOptions.src,
                    src_channel : launchOptions.channel,
                    inviteCode: launchOptions.inviteCode,
                    textId: launchOptions.textId,
                    gameVersion: game_version,
                    invokeUser: true,
                    gameClientSetting: GameSpeedManager.getInstance().getSpeedConfig(),
                    deviceInfo: getDeviceInfo(),
                    equipment_type: launchOptions.equipment_type,
                    ad_params: launchOptions.adParams
                }
            } catch (error) {
                // var params2 = {"message":"登陆校验 loginInfo出错"+error.stack}  
                // HwFastappObject.install(JSON.stringify(params2)) 
            }
          
     

            if (launchOptions.channel_id) 
                loginInfo.channel_id = launchOptions.channel_id;
            console.log("[hw] window._ad_channel=", window._ad_channel)
            console.log("[hw] window._oaid=", window._oaid)
            if (window._ad_channel && window._oaid){
                loginInfo.ad_params = _ad_channel
                loginInfo.oaid = _oaid
            }
            console.log("huawei logininfo ", JSON.stringify(loginInfo))

            HttpEncryptedLogic.getInstance().setSecretKeyMsgByVersion(window.HTTP_SECRET_KEY_VERSION)
            callback && callback(loginInfo)
        })
    }else if (window.OPEN_DATA && window.OPEN_DATA.openid && window.OPEN_DATA.openkey) { //wanba
        let oldOpenKey = window.OPEN_DATA.openkey
        GameProxy.getInstance().getLoginInfo(function(data) {
            if (oldOpenKey !== data.openkey) {
                DCAssist.userTrack("error", "openKeyNotMatck", { old: oldOpenKey, data: data.openkey })
                META.user.openkey = data.openkey
            }
            window.OPEN_DATA.openid = data.openid
            window.OPEN_DATA.openkey = data.openkey

            let launchOptions = getLaunchOptions();
            let loginInfo = {
                openid: data.openid,
                openkey: data.openkey,
                serverid: window.OPEN_DATA.platform,
                pf: window.META.user.platform,
                //pf: window.META.user.pf,
                op: 'login',
                src: launchOptions.src,
                src_channel : launchOptions.channel,
                inviteCode: launchOptions.inviteCode,
                textId: launchOptions.textId,
                gameVersion: game_version,
                invokeUser: true,
                gameClientSetting: GameSpeedManager.getInstance().getSpeedConfig(),
                deviceInfo: getDeviceInfo(),
                equipment_type: launchOptions.equipment_type,
                ad_params: launchOptions.adParams
            }
            if (launchOptions.channel_id) 
                loginInfo.channel_id = launchOptions.channel_id;

            HttpEncryptedLogic.getInstance().setSecretKeyMsgByVersion(window.HTTP_SECRET_KEY_VERSION)
            callback && callback(loginInfo)
        })
    } else if (isWechatGameEnv()) {
        let callbackCnt = 0
        let callbackCntMax = 1
        let loginInfo = {}
        let wechatCallback = function(){
            callbackCnt = callbackCnt + 1
            if (callbackCnt >= callbackCntMax){
                callback && callback(loginInfo)
            }
        }
        // if (window.mini && mini.getPlatform() == MiniPlatform.wechatGame){
        //     callbackCntMax = 2
        //     if (HttpEncryptedLogic.getInstance().hasKey){
        //         QAGUI.getInstance().print("has preGet latestUserKey", "Preload")
        //         wechatCallback()
        //     }else{
        //         QAGUI.getInstance().print("getLatestUserKey 1:"+Localhost.time(), "Preload")
        //         let hasFinish = false
        //         mini.getLatestUserKey((encryptKey, iv, version, expireTime)=>{
        //             if (hasFinish == true){
        //                 return
        //             }
        //             hasFinish = true
        //             QAGUI.getInstance().print("getLatestUserKey 2:"+Localhost.time(), "Preload")
        //             // loginInfo.msgEncryptIv = iv
        //             loginInfo.wxKeyVersion = version
        //             // loginInfo.msgEncryptKey = encryptKey
        //             HttpEncryptedLogic.getInstance().setSecretKeyMsg(encryptKey,iv,version)
        //             cc.log("encrypt  getCurrentEvt loginInfo ",loginInfo)
        //             wechatCallback()
        //         },()=>{
        //             if (hasFinish == true){
        //                 return
        //             }
        //             hasFinish = true
        //             DCAssist.dc4Encrypt("encrypt_fail", "", "on_key",mini.version)
        //             wechatCallback()
        //         })
        //         setTimeout(()=>{
        //             if (hasFinish == true){
        //                 return
        //             }
        //             hasFinish = true
        //             DCAssist.dc4Encrypt("encrypt_fail", "", "timeout",mini.version)
        //             wechatCallback()
        //         }, 3000)
        //     }
        // }
        QAGUI.getInstance().print("getLoginInfo 1:"+Localhost.time(), "Preload")
        GameProxy.getInstance().getLoginInfo(function (data) {
            QAGUI.getInstance().print("getLoginInfo 2:"+Localhost.time(), "Preload")
            META.user.openid = data.h5game_openid
            META.user.sessionid = data.h5sdk_sessionid

            let launchOptions = getLaunchOptions();
            // TODO: 判断openid和sessionid是否为空
            loginInfo = {
                serverid: 1,
                pf: mini.getPlatform(),
                op: "login",
                src: launchOptions.src,
                src_channel : launchOptions.channel,
                inviteCode: launchOptions.inviteCode,
                textId: launchOptions.textId,
                wxScene: launchOptions.wxScene,
                gameVersion: game_version,
                h5game_openid: data.h5game_openid,
                h5sdk_sessionid: data.h5sdk_sessionid,
                rawData: data.rawData,
                signature: data.signature,
                gameClientSetting: GameSpeedManager.getInstance().getSpeedConfig(),
                pkgName:data.pkgName,
                token:data.token,
                invokeUser: true,
                avatarUrl:data.avatarUrl,
                deviceInfo: getDeviceInfo(),
                equipment_type: launchOptions.equipment_type,
                ad_params: launchOptions.adParams,
                nickName: data.nickName
            }
            if (data.notUpdateAvatar){
                // 告诉后端不需要更新头像
                loginInfo.notUpdateAvatar = data.notUpdateAvatar
            }
            if (launchOptions.channel_id) 
                loginInfo.channel_id = launchOptions.channel_id;
            mini.setAdditionalLoginInfo(loginInfo, data);
            loginInfo.user_platform = mini.isPlatformLogin()? "2": "1";    // 游客标识 1：游客；2：端登陆用户

            // 可能失败有failRetry
            if (data.failRetry){
                loginInfo.failRetry = data.failRetry;
            }
            HttpEncryptedLogic.getInstance().setSecretKeyMsgByVersion(window.HTTP_SECRET_KEY_VERSION)

            if (window.mini && mini.getPlatform() == MiniPlatform.tt){
                loginInfo.session_key = data.session_key;
                loginInfo.nickName = data.nickName;
                // 抖音判断可能是从发布的视频进来的
                CfgManager.load("game")
                .then(()=> {
                    let config = CfgManager.get("game");
                    var videoScene = config.douyin_game_video_scene || ["023001","023002","026002"];
                    CfgManager.release("game");
                    for(var i = 0; i < videoScene.length; i++){
                        if (loginInfo.wxScene == videoScene[i]){
                            loginInfo.src = "feed_video_share";
                        }
                    }
                    callback && callback(loginInfo)
                })
                .catch((error)=> {
                    callback && callback(loginInfo)
                })
                return;
            }

            if (window.mini && mini.getPlatform() == MiniPlatform.qqlightGame){
                var SnsProxy = require("clover/sns/SnsProxy")
                var chooseData = cc.UserDefault.getInstance().getStringForKey("MULTI_USER_DATA_CHOOSE", "");
                cc.log("----chooseData----", chooseData);
                if (chooseData == null || chooseData == ""){
                    // qq轻游戏登录且QQLIGHTGAME_USER_DATA_CHOOSE空的时候需要检查玩吧数据
                    loginInfo.checkWanba = true;
                }else{
                    // qq轻游戏合并数据版本之后必须要传checkWanba
                    loginInfo.checkWanba = false;
                    chooseData = JSON.parse(chooseData);
                    var choose = chooseData.choose;
                    SnsProxy.getInstance().setLoginChooseForMultiData(choose);
                    if (choose == "wanba_ts"){
                        // 直接登录玩吧
                        loginInfo.pf = choose;
                        loginInfo.openid = chooseData.snsuid;
                        loginInfo.nickName = chooseData.nickname;
                        loginInfo.avatar = chooseData.avatar;
                        loginInfo.serverid = mini.getMetaServerId();
                    }else{
                        // 直接登录qq小游戏
                        loginInfo.serverid = mini.getMetaServerId(); // qq小游戏新增服务器区分
                    }
                }
            }   
            // if (window.mini && mini.getPlatform() == MiniPlatform.wechatGame){
            //     wechatCallback()
            // }else{
            //     callback && callback(loginInfo)
            // }  
            // if (window.mini && mini.getPlatform() == MiniPlatform.wechatGame){
            //     // 暂时只开微信
            // }
            callback && callback(loginInfo)
        },
        //now only baidu need this callback
        function (data){
            
        },
        isPreGet,
        forceNewCode
        )

    } else {
        let openid = cc.UserDefault.getInstance().getStringForKey(LOCAL_IDENTIFY_KEY)
        if (openid === null || openid === '') {
            openid = generateUUID()
            cc.UserDefault.getInstance().setStringForKey(LOCAL_IDENTIFY_KEY, openid)
        }
        let data = {
            op: 'mock_user',
            snsuid: openid,
            // pf: window.META.user.platform,
            pf: "wechatgame",
            sub_pf: META.user.app,
            // platform: 'wanba_ts',
            platform: 'wechatgame',
            src: 'local_test',
            gameVersion: game_version,
            invokeUser: true,
            gameClientSetting: GameSpeedManager.getInstance().getSpeedConfig(),
            deviceInfo: getDeviceInfo()
            // openid  : "4FC715ACA0729314F49F3481D48766C6",
            // openkey : "777AAF1A76420B693B0F7A460E594305",
            // serverid : 1,
            // pf: "wanba_ts",
            // op: "login"
        }

        callback && callback(data)
    }
}

getDeviceInfo = function () {

    //  初始默认值
    let deviceInfo = {
        clientType: "Unknow",
        clientPixel: GamePlayConfig_Design_Width + "*" + GamePlayConfig_Design_Height,
        clientVersion: "Unknow",
        quality: "Unknow",
        model: "",
        wx_version:"",
        modelLevel: 1,
        memorySize: 0
    }

    //  依据平台获取对应数据
    try {     
        if (window.mini && window.mini.getSystemInfoSync) {
            let info = window.mini.getSystemInfoSync();
            if (info.model) {   deviceInfo.clientType = info.model.replace(/[\r|\n|:|,|']/g," ");}
            if (info.screenWidth && info.screenHeight) {    deviceInfo.clientPixel = info.screenWidth + "*" + info.screenHeight};
            if (info.system) {  
                deviceInfo.clientVersion = info.system.replace(/[\r|\n|:|,|']/g," ");
            } else if (info.osVersionName) {
                deviceInfo.clientVersion = info.osVersionName.replace(/[\r|\n|:|,|']/g," ");
            }
            if (info.benchmarkLevel) {  deviceInfo.quality = tostring(info.benchmarkLevel)};
            if (info.platform) {  deviceInfo.platform = info.platform}
            if (info.model) {  deviceInfo.model = info.model}
            if (info.version) {  deviceInfo.wx_version = info.version}
            if (info.benchmarkLevel) {  deviceInfo.quality = info.benchmarkLevel};  // 这个值不再维护了，用modelLevel代替
            if (info.platform) {  deviceInfo.platform = info.platform}
            if (info.model) {  deviceInfo.model = info.model}
            if (info.memorySize) {  deviceInfo.memorySize = info.memorySize}
        }
    }catch(err){
        
    }
    if (window.mini && window.mini.getDeviceInfo){
        // 微信getSystemInfoSync不再维护，需要从getDeviceInfo里取platform
        let info = window.mini.getDeviceInfo()
        if (info && info.platform) {  deviceInfo.platform = info.platform} //ios android windows mac devtools
    }
    if (window.mini && mini.modelLevel){
        deviceInfo.modelLevel = mini.modelLevel
    };

    return deviceInfo;
}

initStringsFile = function(res) {
    for (let key in res) {
        let v = res[key]
        if (!v) {
            continue
        }
        if (string.ends(v, '.strings')) {
            let text = cc.loader.getRes(v)
            he.Localization.init(text)
        }
    }
}

timeoutPromise = function(promiseOrFunc, timeout) {
    let promise
    if (typeof promiseOrFunc === 'function') {
        promise = promiseOrFunc()
    } else if (promiseOrFunc instanceof Promise) {
        promise = promiseOrFunc
    }
    if (timeout) {
        let timer
        let racer = new Promise((resolve, reject) => {
            timer = setTimeout(() => reject('time out'), timeout)
        })
        return Promise.race([promise, racer]).then(value => {
            clearTimeout(timer)
            return value
        })
    } else {
        return promise
    }
}

isChallengeMode = function (mainLogic) {
    let contestUid = mainLogic && mainLogic.PlayUIDelegate && mainLogic.PlayUIDelegate.extraData && mainLogic.PlayUIDelegate.extraData.contestUid
    return typeof contestUid !== "undefined"
}


/**
 * 根据全局路径字符串获取对象,如 getObjectByPath("cc.Node") === cc.Node
 */
getObjectByPath = function (path) {
    let root = window
    if (!root["__OBJ_PATH_CACHE"]) {
        root["__OBJ_PATH_CACHE"] = {};
    }
    if (root["__OBJ_PATH_CACHE"].hasOwnProperty(path)) {
        return root["__OBJ_PATH_CACHE"][path]
    }else{
        let pathList = path.split(".")
        let target = null
        let parent = root
        for (let i = 0; i < pathList.length; i++) {
            if (parent.hasOwnProperty(pathList[i])) {
                target = parent[pathList[i]]
                parent = target
            }     
        }
        root["__OBJ_PATH_CACHE"][path] = target
        return target
    }
}

/**授权成功刷新 */
refreshAuthorize = function(){
    if (!window.mini || !window.mini.supportAuthorize() || !mini.supportGetUserInfo()){
        return
    }
    window.mini.getUserInfo({
        withCredentials:true,
        success:function(data){
            if (data.rawData){
                let infoData = JSON.parse(data.rawData)
                Localhost.setSnsUserInfo(null, infoData.nickName, null, infoData.avatarUrl, null)
                var http = AuthorizeHttp.new()
                http.addEventListener(Events.kComplete, (res)=>{
                    console.log("[####]authorizehttp success:"+JSON.stringify(data))
                    var profile = UserManager.getInstance().profile
                    profile.headUrl = res.data.avatarUrl
                    profile.name = res.data.nickName
                })
                http.addEventListener(Events.kError, (res)=>{console.log("[####]authorizehttp error")})
                http.load({
                    openid: cc.UserDefault.getInstance().getStringForKey("h5game_openid"),
                    sessionid: cc.UserDefault.getInstance().getStringForKey("h5sdk_sessionid"),
                    rawData:data.rawData,
                    signature:data.signature
                })
            }
        },
        fail:function(){
            console.log("[####]get user info failed")
        }
    })
}
// 合并数据到数组 k为对比值 v_k为合并叠加值
mergeDataToArr = function(arr,data,k,v_k){
    let index = -1
    for (let i = 0; i < arr.length; i++) {
        if (arr[i][k] == data[k]){
            index = i
        }
    }
    if (index ==  -1){
        arr.push(data)
    }else{
        arr[index][v_k] += data[v_k]
    }
}
iosNeedUseLow = function(model,brand){
    console.error("iosNeedUseLow model ",model,brand)
    if (brand != "iPhone" || !brand ) return false
    const LOW_LIST = [
        "iPhone 5",
        "iPhone 6",
        "iPhone 7",
        "iPhone 8",
        "iPhone 12",
        "iPhone SE",
        "iPhone X",//XR XS
    ]
    for (let i = 0; i < LOW_LIST.length; i++) {
        let str = LOW_LIST[i]
        if (model.startsWith(str))  {
            return true
        }      
    }
    // console.error("iosNeedUseLow return false ")
    return false
}

checkSupportETC = function(canvas, forceBanEtc){
    if (window.mini && window.mini.supportETC(canvas, forceBanEtc)){
        let deviceInfo = getDeviceInfo()
        if (tonumber(deviceInfo.modelLevel) < 3 && tonumber(deviceInfo.memorySize) > 11000){
            return false
        }
        return true
    }
    return false
}